<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { globalEnergieWaermequelleCollection } from '@/models/EnergieWaermequelle';
import { type Ref } from 'vue';

const value: Ref<any> = defineModel();

defineProps<{
    label?: string;
}>();

const codes = globalEnergieWaermequelleCollection();
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="codes.getModels()"
        :option-label="(v: any) => $t(v.i18n_key) + ' (' + v.code + ')'"
        option-value="id"
    ></KpSelectField>
</template>
